<script setup>
import { computed } from 'vue';

const props = defineProps({
  origin: {
    type: Object,
    required: true,
  },
});

// Ad ids are long and opaque. When the headline is what gets shown, the id
// still travels in the tooltip so the original attribution stays recoverable
// from the row itself.
const tooltip = computed(() => {
  const { adId, headline } = props.origin;
  return headline && adId ? `${headline} · ${adId}` : headline || adId;
});
</script>

<template>
  <span
    v-tooltip.top="tooltip"
    class="inline-flex items-center gap-1 px-1.5 py-0.5 max-w-full rounded-md bg-n-alpha-2 text-n-slate-11 text-xxs"
  >
    <fluent-icon icon="megaphone" size="12" class="flex-shrink-0" />
    <span class="truncate">{{ origin.label }}</span>
  </span>
</template>
